module.exports = __webpack_public_path__ + "img/rebuild_huang_pc_bg.a430d9d4.png";